var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDogsFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 10H15.652C17.36 10 18.282 12.004 17.17 13.302L15.552 15.189C15.727 16.3083 16.3175 17.3204 17.2059 18.0234C18.0943 18.7264 19.215 19.0686 20.3446 18.9816C21.4741 18.8946 22.5293 18.3849 23.2995 17.5542C24.0698 16.7235 24.4985 15.6329 24.5 14.5C24.5 14.1022 24.658 13.7206 24.9393 13.4393C25.2206 13.158 25.6022 13 26 13C26.3978 13 26.7794 13.158 27.0607 13.4393C27.342 13.7206 27.5 14.1022 27.5 14.5C27.5 16.0741 27.0047 17.6083 26.0843 18.8853C25.1639 20.1623 23.865 21.1173 22.3717 21.6151C20.8784 22.1129 19.2663 22.1282 17.7637 21.6589C16.2612 21.1895 14.9445 20.2593 14 19C13.0555 20.2593 11.7388 21.1895 10.2363 21.6589C8.73374 22.1282 7.12163 22.1129 5.62829 21.6151C4.13495 21.1173 2.83609 20.1623 1.91568 18.8853C0.99528 17.6083 0.5 16.0741 0.5 14.5C0.5 14.1022 0.658035 13.7206 0.93934 13.4393C1.22064 13.158 1.60218 13 2 13C2.39782 13 2.77936 13.158 3.06066 13.4393C3.34196 13.7206 3.5 14.1022 3.5 14.5C3.49826 15.6349 3.92537 16.7285 4.69578 17.5618C5.46619 18.3951 6.523 18.9065 7.65452 18.9936C8.78603 19.0808 9.90868 18.7371 10.7976 18.0316C11.6865 17.3261 12.276 16.3107 12.448 15.189L10.83 13.302C9.718 12.004 10.64 10 12.35 10H14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 6C22.6569 6 24 4.65685 24 3C24 1.34315 22.6569 0 21 0C19.3431 0 18 1.34315 18 3C18 4.65685 19.3431 6 21 6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 6C8.65685 6 10 4.65685 10 3C10 1.34315 8.65685 0 7 0C5.34315 0 4 1.34315 4 3C4 4.65685 5.34315 6 7 6Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDogsFooter);
export default __webpack_public_path__ + "static/media/dogs-footer.bb25bf58901f93b20e07bfd8deedb34b.svg";
export { ForwardRef as ReactComponent };